module.exports = __webpack_public_path__ + "img/react-mobile.c805a6e2.svg";